import { DepartmentInfo, InsuranceCompanySeed } from '../../shared/models/domain/InsuranceCompanySeed';
import { EcapUser } from '../../app-user-management/model/user-access-management.model';
import { IKeyValuePair } from '../../shared/models/common.model';

export class CaseSearchFilter {
    ClaimNumber: string = null;
    CaseReportNumber: string = null;
    CaseStatus: IKeyValuePair = null;
    MultipleCaseStatus: IKeyValuePair[] = [];
    InsuranceCompany = new InsuranceCompanySeed();
    Department = new DepartmentInfo();
    OrderFrom: Date | string = null;
    OrderTo: Date | string = null;
    InspectorUserId: string = null;
    BackofficeUserId: string = null;
    QualityCheck: IKeyValuePair = null;
    EmailSendFrom: Date | string = null;
    EmailSendTo: Date | string = null;
    CreateDateFrom: Date | string = null;
    CreateDateTo: Date | string = null;
    IsMarkedForQualityCheck: boolean = null;
    InspectorStatus: IKeyValuePair = null;
    SLAType: string;
    DocumentProcessingStatus: string;
    SLAStartDate: Date = null;
    SLAExpiredDate: Date = null;
    IsRegulated: boolean | null = null;
    BexioInvoiceId: string | null = null;
    IsDraft: boolean | null = null;
    Language: string | null = null;
    ServiceProductId: string | null = null;
    ReadyForBillingFromDate: Date | string = null;
    ReadyForBillingToDate: Date | string = null;
    InvoiceFromDate: Date | string = null;
    InvoiceToDate: Date | string = null;
    IsQuickSearch: boolean;
    SearchKey: string;
    AllCases: boolean;
    LoggedUserInfo: EcapUser;
    SortBy: string | null = null;
    DepartmentIds: string[] = [];
    ConnectedRepairCaseFilter: string = null;
    InsuranceCompanys: InsuranceCompanySeed[] = [];

    InsuranceCompanyId: string;
    DepartmentId: string;

    constructor(data: any = {}) {
        this.ClaimNumber = data.ClaimNumber ?? null;
        this.CaseReportNumber = data.CaseReportNumber ?? null;
        this.CaseStatus = data.CaseStatus ?? null;
        this.MultipleCaseStatus = data.MultipleCaseStatus ?? [];
        this.InsuranceCompany = data.InsuranceCompany ?? null;
        this.Department = data.Department ?? null;
        this.OrderFrom = data.OrderFrom ?? null;
        this.OrderTo = data.OrderTo ?? null;
        this.QualityCheck = data.QualityCheck ?? null;
        this.EmailSendFrom = data.EmailSendFrom ?? null;
        this.EmailSendTo = data.EmailSendTo ?? null;
        this.CreateDateFrom = data.CreateDateFrom ?? null;
        this.CreateDateTo = data.CreateDateTo ?? null;
        this.InspectorUserId = data.InspectorUserId ?? null;
        this.BackofficeUserId = data.BackofficeUserId ?? null;
        this.IsMarkedForQualityCheck = data.IsMarkedForQualityCheck ?? null;
        this.InspectorStatus = data.InspectorStatus ?? null;
        this.SLAType = data.SLAType ?? null;
        this.DocumentProcessingStatus = data.DocumentProcessingStatus ?? null;
        this.SLAStartDate = data.SLATypeDetails?.SLAStartDate ?? null;
        this.SLAExpiredDate = data.SLATypeDetails?.SLAExpiredDate ?? null;
        this.IsRegulated = data.IsRegulated ?? null;
        this.BexioInvoiceId = data.BexioInvoiceId ?? null;
        this.IsDraft = data.IsDraft ?? null;
        this.Language = data.Language ?? null;
        this.ServiceProductId = data.ServiceProductId ?? null;
        this.ReadyForBillingFromDate = data.ReadyForBillingFromDate ?? null;
        this.ReadyForBillingToDate = data.ReadyForBillingToDate ?? null;
        this.InvoiceFromDate = data.InvoiceFromDate ?? null;
        this.InvoiceToDate = data.InvoiceToDate ?? null;
        this.IsQuickSearch = data.IsQuickSearch ?? false;
        this.SearchKey = data.SearchKey ?? null;
        this.AllCases = data.AllCases ?? false;
        this.LoggedUserInfo = data.LoggedUserInfo ?? new EcapUser();
        this.SortBy = data.SortBy ?? null;
        this.DepartmentIds = data.DepartmentIds ?? [];
        this.InsuranceCompanys = data.InsuranceCompanys ?? [];

        this.InsuranceCompanyId = data.InsuranceCompanyId ?? null;
        this.DepartmentId = data.DepartmentId ?? null;
    }
}
